import React from "react";
import Slider from "react-slick";
import { resolveImageSrc } from "@demant/wdh";
import { addTrackingToProductClick } from "../../../../../../js/feature/gtm-tracking";

const isRTL = document.body.classList.contains("page-dir-rtl");

class SliderView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: 0,
    };

    this.items = this.getItems(this.props.list);
  }

  getItems = (items) => {
    if (!isRTL) return items;
    const reversedItems = [...items].reverse();
    const lastItem = reversedItems.pop();
    reversedItems.unshift(lastItem);
    return reversedItems;
  };

  checkIfElementHasContent(el) {
    const withoutSpace = el.trim().replace("&nbsp;", "");
    return withoutSpace.length > 0;
  }

  getSliderTrackHeight() {
    setTimeout(() => {
      const height = this.slider.innerSlider.track.node.clientHeight;
      this.slider.innerSlider.track.node.style.height = `${height + 14}px`;
      this.props.updateInitiated(true);
    }, 500);
  }

  getSliderTrackHeightOnResize() {
    this.props.updateInitiated(false);
    this.slider.innerSlider.track.node.style.height = "auto";
    this.getSliderTrackHeight();
  }

  componentDidMount() {
    this.getSliderTrackHeight();
    window.addEventListener("resize", () => {
      this.getSliderTrackHeightOnResize();
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => {
      this.getSliderTrackHeightOnResize();
    });
  }

  render() {
    const sliderSettings = {
      className: this.props.isInitated ? "initiated" : "",
      infinite: true,
      speed: 800,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      focusOnSelect: true,
      centerPadding: "0",
      beforeChange: (current, next) => {
        this.setState({ activeIndex: next });
      },
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 767,
          arrows: true,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
    return (
      <Slider ref={(slider) => (this.slider = slider)} {...sliderSettings}>
        {this.items.map((item, index) => {
          const imgSrc = item.image ? resolveImageSrc(item.image) : "";
          const hasDetails =
            (item.text && this.checkIfElementHasContent(item.text)) ||
            item.link;
          return (
            <div
              className={`image-spot-element ${
                this.state.activeIndex === index ? "active" : ""
              }`}
              key={index}
            >
              <div className="inner-container">
                {item.image && (
                  <div className="image-spot-element-image">
                    <img
                      src={imgSrc}
                      alt={item.image.alt}
                      width={item.image.width}
                      height={item.image.height}
                    />
                  </div>
                )}
                {item.header && this.checkIfElementHasContent(item.header) && (
                  <div
                    className="image-spot-element-header"
                    dangerouslySetInnerHTML={{ __html: item.header }}
                  />
                )}
                {hasDetails && (
                  <div className="image-spot-element-container">
                    {item.text && this.checkIfElementHasContent(item.text) && (
                      <div
                        className="image-spot-element-text"
                        dangerouslySetInnerHTML={{ __html: item.text }}
                      />
                    )}
                    {item.link && (
                      <div className="image-spot-element-link">
                        <a
                          href={item.link.href}
                          className={item.link.class}
                          tabIndex={this.state.activeIndex === index ? 0 : -1}
                          onClick={(e) =>
                            addTrackingToProductClick(
                              e,
                              item.link.href,
                              item.link.target,
                              "button_click"
                            )
                          }
                        >
                          {item.link.content}
                        </a>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </Slider>
    );
  }
}

export default SliderView;
